import { init } from "@plausible-analytics/tracker";
import * as Sentry from "@sentry/react";
import { BrowserRouter, Route, Routes } from "react-router";

import NavigatorWithRouter from "./components/NavigatorWithRouter";
import config from "./config";
import { setPreviewNotification, setPreviewSituations } from "./model/actions";
import store from "./model/store";

import "./App.scss";

init({
  // For dev purposes only
  // captureOnLocalhost: true,
  domain: "tralis.sbahnm.geops.de",
  endpoint: "https://plausible.geops.io/api/event",
  hashBasedRouting: true,
  outboundLinks: true,
});

Sentry.init({
  dsn: "https://481d59f6abeb438faf4ebfdcc6728ca3@sentry.geops.de/3",
  environment: config.sentryEnvironment,
  release: config.sentryRelease,
});

window.addEventListener("message", (event) => {
  // console.log("Message received", event.data);
  if (event.data.notification) {
    // TO DELETE: only for backward compatibility
    store.dispatch(setPreviewNotification(event.data.notification));
  } else if (event.data.notifications?.[0]) {
    // TO DELETE: only for backward compatibility
    store.dispatch(setPreviewNotification(event.data.notifications[0]));
  } else if (event.data.situations) {
    store.dispatch(setPreviewSituations(event.data.situations));
  }
});
// warn the parent that the web component is listening
window.parent?.postMessage({ data: true, type: "mwc:messageready" }, "*");

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          element={<NavigatorWithRouter useLocalStorage={true} />}
          path="/navigator/:stationId?"
        />
        <Route
          element={<NavigatorWithRouter useLocalStorage={false} />}
          exact
          path="/:stationId?"
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
